import { render, staticRenderFns } from "./AlvoradaSolicitacaoCirurgiaProtocoloFornecedor.vue?vue&type=template&id=1d1bbbdc&scoped=true"
import script from "./AlvoradaSolicitacaoCirurgiaProtocoloFornecedor.vue?vue&type=script&lang=ts"
export * from "./AlvoradaSolicitacaoCirurgiaProtocoloFornecedor.vue?vue&type=script&lang=ts"
import style0 from "./AlvoradaSolicitacaoCirurgiaProtocoloFornecedor.vue?vue&type=style&index=0&id=1d1bbbdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1bbbdc",
  null
  
)

export default component.exports